import React, { useState, useEffect } from 'react';
import { Link,Navigate, useParams } from 'react-router-dom';
import Navbar from '../navbar/navbar';
import './grupo.css'
import { api } from '../../services/api';
import { vhostV1, vhostV2 } from '../funcoes';
import SweetAlert from 'react-bootstrap-sweetalert';
import customizeScrollbar from "customsb";
import FooterBar from '../footer/footerBar';
import SRI_pagination from '../components/pagination/pagination';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import GrupoProdutosPdf from '../reports/grupos/relGrupos';
import GrupoProdutosExcel from '../reports/grupos/relGruposExcel';
import { setRef } from '@mui/material';




function Grupo() {

  const {tag} = useParams();

     const [texto,setTexto] = useState('');
     const [busca,setBusca] = useState("");
     const [grupos,setGrupos] = useState([]);
     const [load,setLoad] = useState(false);
     const [nPag,setnPag] = useState(1);
     const [totalPaginas,setTotalPaginas] = useState(0); 
     const [tpBusca,setTpBusca] = useState(0);
    
     const [produtos,setProdutos] = useState([]);
     const [sResult,setSresult] = useState(0);
     const [erroValidacao, setErrovalidacao] = useState(false);
     const [msgErro, setmsgErro] = useState('') ;
     const [dCadastro,setDcadastro] = useState(new Date);
     const [dAlteracao,setDalteracao] = useState(new Date);
     const [dultCompra,setDultcompra] = useState(new Date);
     const [dultVenda,setDultvenda] = useState(new Date);

     const [usaDcadastro,setUsaDcadastro] = useState(false);
     const [usaDAlteracao,setusaDalteracao] = useState(false);
     const [usaDultCompra,setusaDultcompra] = useState(false);
     const [usaDultVenda,setusaDultvenda] = useState(false);

     const [mensagem, setMensagem] = useState('');  
     const [sucesso, setSucesso] = useState('N');
     const [refresh, setRefresh] = useState(false);

     const [cGrupo,setCgrupo] = useState(0);
     const [cSubGrupo,setCsubGrupo] = useState(0);
     const [cLinha,setClinha] = useState(0);


     const [diferenteZero,setDiferenteZero] = useState(false);
     const [estoqueNegativo,setEstoqueNegativo] = useState(false);
     const [vendaZerada,setVendaZerada] = useState(false);
     const [prodInativo,setProdInativo] = useState(false);

     const [navegar, setNavegar] = useState(false);
     const [confirmacao,setConfirmacao] = useState(false);
     const [confirmacaoId,setConfirmacaoID] = useState('');
     const [result, setResult] = useState(0);
     const [selectRelatorio, setSelectRelatorio] = useState(false);
     const [tpRelatorio, setTprelatorio] = useState(0);
     const [titulo, setTitulo] = useState('');

     const [showModalSub, setShowModalSub] = useState(false);
const [descricaoSub, setDescricaoSub] = useState('');
const [markup, setMarkup] = useState(0);
const [cod_grupo, setCodGrupo] = useState(0);
const [id, setId] = useState(-1);
const [confirmacaoSub, setConfirmacaoSub] = useState(false);

const [showModalLinha, setShowModalLinha] = useState(false);
const [descricaoLinha, setDescricaoLinha] = useState('');
const [cod_subgrupo, setCodSubgrupo] = useState(0);
const [cod_linha, setCodLinha] = useState(-1);
const [confirmacaoLinha, setConfirmacaoLinha] = useState(false);

     const [gruposAbertos, setGruposAbertos] = useState({});
const [subgruposAbertos, setSubgruposAbertos] = useState({});

      function deleteUser(id){
        api.delete(vhostV1('webcash/grupos/'+Number(id)),config)
          .then(function (response) {
            console.log(response);
            
            setConfirmacao(false);
            setNavegar(true);
                    
          })
          .catch(function (error) {
            console.log(error);
            setConfirmacao(false);
            
          });
        
      
      }

      const toggleGrupo = (codGrupo) => {
  setGruposAbertos(prev => ({
    ...prev,
    [codGrupo]: !prev[codGrupo]
  }));
};

const toggleSubgrupo = (codSubgrupo) => {
  setSubgruposAbertos(prev => ({
    ...prev,
    [codSubgrupo]: !prev[codSubgrupo]
  }));
};

      useEffect(function(){
        if(Number(tag) === 1){
          setTitulo('SRI Web');
        }else if(Number(tag) === 2){
          setTitulo('Catálogo Web');
        }else if(Number(tag) === 3){
          setTitulo('Auto-Atendimento');
        }else{
          setTitulo('');
        }
      },[tag])

      function handlePageChange(value){
        if(value === "&laquo;" || value === '... '){
          setnPag(1);
        }else if (value === "&lsaquo;" ){
          if (nPag !== 1){
            setnPag(nPag -1);
          }
        }else if(value === "&rsaquo;"){
          setnPag(nPag +1);        
        }else if(value === "&raquo;" || value === ' ...' ){
          setnPag(totalPaginas);        
        }else{
          setnPag(value);
        }    
       
       }

      useEffect(function(){
        setLoad(true)
        //console.log('numero de Paniga '+nPag);
        const sJson = {}
        sJson.loja=localStorage.getItem('loja'); 
        sJson.empresa=0;
        sJson.grupo=cGrupo;
        sJson.subgrupo=cSubGrupo;
        sJson.linha=cLinha;
        if(usaDcadastro === true)
        { sJson.data_cadastro=dCadastro}
        if(usaDAlteracao === true)
        { sJson.data_alteracao=dAlteracao}
        if(usaDultCompra === true)
        { sJson.data_compra=dultCompra}
        if(usaDultVenda === true)
        { sJson.data_venda=dultVenda}
        sJson.estoque_diferente=diferenteZero
        sJson.estoque_negativo=estoqueNegativo;
        sJson.preco_zerado=vendaZerada;
        sJson.inativo=false;
        sJson.pagina= nPag;
        sJson.regPag=100000;
        sJson.busca= busca; 
        sJson.tipoBusca=tpBusca;  
        sJson.tipo_prod='';                 
        
          api.post(vhostV1('webcash/produto/listar'),sJson,config)
            .then(function (response) {
              console.log(response.data.dados);           
              setProdutos(response.data.dados); 
              setSresult(response.data.result)
             
              setLoad(false);
              
                                          
                       
            })
            .catch(function (error) {
              setLoad(false);
              console.log(error);
    
                      
            });
      
            
          },[busca,nPag])


          // Função para verificar se um grupo pode ser excluído
function podeExcluirGrupo(id) {
  // Verificar se há produtos associados ao grupo
  const produtosAssociados = produtos.some(produto => produto.COD_GRUPO ===Number(id));
  console.log(produtosAssociados);
  
  
  if (produtosAssociados) {
    console.log(`Não é possível excluir o grupo com código ${id} porque existem produtos associados a ele.`);
    return false;
  }

  return true;
}

    function confirmadeleteUser(id){
      if(podeExcluirGrupo(id) === false){
        
        setmsgErro(`Não é possível excluir o grupo com código ${id} porque existem produtos associados a ele.`);
        setErrovalidacao(true)
      }else{
      setConfirmacaoID(id);
      setConfirmacao(true);
      setBusca('');
      
    }}

     // Aplicando a personalização com opções diferentes
// Abaixo é somente um exemplo de personalização, adapte para o seu projeto
useEffect(() => {
  // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
  customizeScrollbar({
    scrollbarWidth: "10px",
    trackBackground: "#333",
    thumbBackground:
      "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
    thumbBorderRadius: "10px",
  });
}, []);


  let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  

  let config2 = {
    headers: {
      'Authorization': localStorage.getItem("token2")
    }
  }

  //buscar clientes
  useEffect(function(){
   
      api.post(vhostV1('webcash/grupos'), {
          pagina: nPag,
          regPag: 10,
          busca: busca,
          cod_subgrupo: 1
        },config)
        .then(function (response) {
          setResult(response.data.result);
          setTotalPaginas(response.data.quantidadeDePaginas);
          setGrupos(response.data.dados);
          console.log(response); 
                                      
                   
        })
        .catch(function (error) {
         
          console.log(error);

                  
        });
           
        
    },[busca, nPag, refresh])

 

    const getDadosRelatorio = async() => {
      let response = {};
    try {
      response = await api.post(vhostV1('webcash/grupos'), {
          pagina: 1,
          regPag: 10000,
          busca: busca
        },config)
    }
     
    catch(error) {
         
          console.log(error);

                  
        };
  return response.data.dados;
        
    }

     async function handleRelatorioGrupo() {
      if(Number(tpRelatorio) === 0){
      try {
          await gerarRelatorioGrupo();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }}else{
        try {
          await gerarRelatorioGrupoDesc();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }
      }
  }

  async function gerarRelatorioGrupo () { 
    
    
    const tItens = await getDadosRelatorio();
  
    
   
     GrupoProdutosPdf(tItens);
    
  
     
  }

  async function gerarRelatorioGrupoDesc () { 
    
    
    const tItens = await getDadosRelatorio();
  
    
   
    const itensOrdenados = tItens.sort((a, b) => {
        return a.DESCRICAO.localeCompare(b.DESCRICAO, 'pt-BR', { sensitivity: 'base' });
    });

    GrupoProdutosPdf(itensOrdenados);
    
  
     
  }

  
   async function handleRelatorioGrupoExcel() {
      if(Number(tpRelatorio) === 0){
      try {
          await gerarRelatorioGrupoExcel();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }}else{
        try {
          await gerarRelatorioGrupoDescExcel();
      } catch (error) {
          console.error("Erro ao gerar relatório:", error);
      }
      }
  }

  async function gerarRelatorioGrupoExcel () { 
    
    
    const tItens = await getDadosRelatorio();
  
    
   
     GrupoProdutosExcel(tItens);
    
  
     
  }

  async function gerarRelatorioGrupoDescExcel () { 
    
    
    const tItens = await getDadosRelatorio();

    const itensOrdenados = tItens.sort((a, b) => {
        return a.DESCRICAO.localeCompare(b.DESCRICAO, 'pt-BR', { sensitivity: 'base' });
    });
  
    
   
     GrupoProdutosExcel(itensOrdenados);
    
  
     
  }

  function salvaSubGrupo(e){
    e.preventDefault();  

    if(descricaoSub.length === 0){  
      {setmsgErro("DESCRIÇÃO DO GRUPO NÃO PODE ESTAR VAZIO");
          setErrovalidacao(true)}
      return    
  }else if(descricaoSub === ' '){
    {setmsgErro("DESCRIÇÃO DO GRUPO NÃO PODE ESTAR VAZIO");
      setErrovalidacao(true)}
  }
    
    else{

        api.post(vhostV1('webcash/subgrupos/inclui'),{
            COD_GRUPO:Number(cod_grupo),
            COD_SUBGRUPO:Number(id),          
            DESCRICAO:descricaoSub,          
            MARKUP:Number(markup) ?? 0
            
          },config)
        .then(function(response){
            setMensagem('');
            setCodGrupo(0);
            setDescricaoSub('');
            setMarkup(0);
            setId(-1);
            console.log(response)
            setShowModalSub(false);
            setRefresh(!refresh);
        }).catch((erro) =>{
            setMensagem(erro);
            setSucesso('N');
            setShowModalSub(false);
        });
     } }

     function deleteSubgrupo(id){
             api.delete(vhostV1('webcash/subgrupos/'+Number(id)),config)
               .then(function (response) {
                 console.log(response);
                 
                 setConfirmacaoSub(false);
                  setRefresh(!refresh);
                         
               })
               .catch(function (error) {
                 console.log(error);
                 setConfirmacaoSub(false);
                 
               });
             
           
           }

           function confirmadeleteSub(id){
      
      setConfirmacaoID(id);
      setConfirmacaoSub(true);
      setBusca('');
      
    }

     const editarSubgrupo = (sub) => {
  setCodGrupo(sub.COD_GRUPO);
  setId(sub.COD_SUBGRUPO);
  setDescricaoSub(sub.DESCRICAO);
  setMarkup(sub.MARKUP ?? 0);

  setShowModalSub(true);
};

const editarLinha = (linha) => {
  setCodSubgrupo(linha.COD_SUBGRUPO);
  setCodLinha(linha.COD_LINHA);
  setDescricaoLinha(linha.DESCRICAO);
  

  setShowModalLinha(true);
};

function salvaLinha(e){
    e.preventDefault();

    
    

    if(descricaoLinha.length === 0){  
      {setmsgErro("DESCRIÇÃO DO GRUPO NÃO PODE ESTAR VAZIO");
          setErrovalidacao(true)}
      return    
  }else if(descricaoLinha === ' '){
    {setmsgErro("DESCRIÇÃO DO GRUPO NÃO PODE ESTAR VAZIO");
      setErrovalidacao(true)}
  }
    
    else{

        api.post(vhostV1('webcash/linhaProd/inclui'),{
            COD_LINHA:Number(cod_linha),
            COD_SUBGRUPO:Number(cod_subgrupo),          
            DESCRICAO:descricaoLinha          
           
            
          },config)
        .then(function(response){
            setMensagem('');
            setSucesso('S');
            setDescricaoLinha('');
            setCodLinha(-1);
            setCodSubgrupo(0);
            setShowModalLinha(false);
            setRefresh(!refresh);

            console.log(response)
        }).catch((erro) =>{
            setMensagem(erro);
            setSucesso('N');
            
        });
     } }

     function deleteLinha(id){
             api.delete(vhostV1('webcash/linhaProd/'+Number(id)),config)
               .then(function (response) {
                 console.log(response);
                 
                 setConfirmacaoLinha(false);
                 setRefresh(!refresh);
                         
               })
               .catch(function (error) {
                 console.log(error);
                 setConfirmacaoLinha(false);
                 
               });
             
           
           }

           function confirmadeleteLinha(id){
      
      setConfirmacaoID(id);
      setConfirmacaoLinha(true);
      setBusca('');
      
    }

    return <div>
        <Navbar/>
        <div className="container-fluid titulo offset-lg-1 col-lg-10">
        <h1>Classificação Mercadológica {`${titulo}`}</h1>
        <hr />

        <div className="row">
          <div className="col-4 mb-2">
            <Link to='/app/novoGrupo/-1' className="btn btn-primary btn-cli" type="button"><i className="bi bi-plus-circle-fill"></i> Grupo</Link>
            <button 
             id='botao-produto' 
             className="btn btn-danger btn-cli mt-2" 
             type="button"
             onClick={() => setSelectRelatorio(true)}
             >
           <i className="bi bi-printer-fill"></i> Relatório
           </button>

          </div>

          <div className="col-8">
            <div className="input-group mb-3">
              <input onChange={(e) => setTexto(e.target.value)} type="text" className="form-control" placeholder="Digite sua pesquisa" aria-describedby="button-addon2" />
              <button onClick={(e) => setBusca(texto)} className="btn btn-primary" type="button" id="button-addon2">Pesquisar</button>
            </div>
          </div>
        </div>   

         <table id='table-grupos' className="table table-hover table-striped">
            <thead>
            <tr>
                <th scope='col'>Código</th>
                <th scope="col">Descricao</th>
                <th scope="col">Mobile</th>
                <th scope="col">Ações</th>
                </tr>
            </thead>
            <tbody className="table-group-divider">
              {Number(result) === 1 ?  
  grupos.map((grupo) => {
    const temSubgrupo = grupo.SUBGRUPOS && grupo.SUBGRUPOS.length > 0;
    const aberto = gruposAbertos[grupo.COD_GRUPO];

    return (
      <React.Fragment key={grupo.COD_GRUPO}>
        
        {/* GRUPO */}
        <tr>
          <td>
            {temSubgrupo && (
              <button 
                className="btn btn-sm btn-link"
                onClick={() => toggleGrupo(grupo.COD_GRUPO)}
              >
                {aberto ? '▼' : '▶'}
              </button>
            )}
            {grupo.COD_GRUPO}
          </td>

          <td>{grupo.DESCRICAO}</td>
          <td>{grupo.CARGA === '1' ? 'SIM' : 'NÃO'}</td>

          <td> <div id="table-prod" className="dropdown">
             <button id='table-prod' className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"> Ações </button> 
             <ul className="dropdown-menu"> 
              <li><button 
  className="dropdown-item"
  onClick={() => {
    setCodGrupo(grupo.COD_GRUPO);
    setShowModalSub(true);
  }}
><i className="bi bi-plus-circle-fill"></i>
   Subgrupo
</button></li>
              <li> <Link to={'/app/novoGrupo/'+grupo.COD_GRUPO} className="dropdown-item"> 
              <i className="bi bi-pen-fill"></i> Editar </Link> </li> 
              <li> <button onClick={() => confirmadeleteUser(grupo.COD_GRUPO)} className="dropdown-item"> 
                <i className="bi bi-trash-fill"></i> Excluir </button>
                 </li>
                  </ul>
                   </div>
                    </td>
        </tr>

        {/* ================= SUBGRUPOS ================= */}
        {aberto && temSubgrupo && (
          <tr>
            <td colSpan="4" style={{ padding: 0 }}>

              <table className="table mb-0 table-sm">
                <thead style={{ background: '#e9ecef' }}>
                  <tr>
                    <th>Cód. Subgrupo</th>
                    <th>Descrição</th>
                    <th>Markup</th>
                    <th>Ações</th>
                  </tr>
                </thead>

                <tbody>
                  {grupo.SUBGRUPOS.map((sub) => {
                    const temLinha = sub.LINHAS?.length > 0;
                    const subAberto = subgruposAbertos[sub.COD_SUBGRUPO];

                    return (
                      <React.Fragment key={sub.COD_SUBGRUPO}>

                        {/* SUBGRUPO */}
                        <tr>
                          <td>
                            {temLinha && (
                              <button
                                className="btn btn-sm btn-link"
                                onClick={() => toggleSubgrupo(sub.COD_SUBGRUPO)}
                              >
                                {subAberto ? '▼' : '▶'}
                              </button>
                            )}
                            {sub.COD_SUBGRUPO}
                          </td>

                          <td>{sub.DESCRICAO}</td>
                          <td>{sub.MARKUP}</td>

                          <td> <div id="table-prod" className="dropdown">
             <button id='table-prod' className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"> Ações </button> 
             <ul className="dropdown-menu"> 
              <li><button 
  className="dropdown-item"
  onClick={() => {
    setCodSubgrupo(sub.COD_SUBGRUPO);
    setShowModalLinha(true);
  }}
><i className="bi bi-plus-circle-fill"></i>
   Linha
</button></li>
              <li> <button onClick={() => editarSubgrupo(sub)} className="dropdown-item"> 
              <i className="bi bi-pen-fill"></i> Editar </button> </li> 
              <li> <button onClick={() => confirmadeleteSub(sub.COD_SUBGRUPO)} className="dropdown-item"> 
                <i className="bi bi-trash-fill"></i> Excluir </button>
                 </li>
                  </ul>
                   </div>
                    </td>
                        </tr>

                        {/* ================= LINHAS ================= */}
                        {subAberto && temLinha && (
                          <tr>
                            <td colSpan="4" style={{ padding: 0 }}>

                              <table className="table mb-0 table-sm">
                                <thead style={{ background: '#dee2e6' }}>
                                  <tr>
                                    <th>Cód. Linha</th>
                                    <th>Descrição</th>
                                    <th>Ações</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {sub.LINHAS.map((linha) => (
                                    <tr key={linha.COD_LINHA}>
                                      <td>{linha.COD_LINHA}</td>
                                      <td>{linha.DESCRICAO}</td>
                                      <td> <div id="table-prod" className="dropdown">
             <button id='table-prod' className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"> Ações </button> 
             <ul className="dropdown-menu"> 
              <li> <button onClick={() => editarLinha(linha)}  className="dropdown-item"> 
              <i className="bi bi-pen-fill"></i> Editar </button> </li> 
              <li> <button onClick={() => confirmadeleteLinha(linha.COD_LINHA)} className="dropdown-item"> 
                <i className="bi bi-trash-fill"></i> Excluir </button>
                 </li>
                  </ul>
                   </div>
                    </td>
                                    </tr>
                                  ))}
                                </tbody>

                              </table>

                            </td>
                          </tr>
                        )}

                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>

            </td>
          </tr>
        )}

      </React.Fragment>
    );
  })
: BuscaVazaia}
            </tbody>
          </table>

          <div className="row mt-5">
              
            <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
            </div>

          {
           erroValidacao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErrovalidacao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }

          {
           confirmacao ? 
           <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle='ligth'
              title="Atenção"
              onConfirm={() =>deleteUser(confirmacaoId)}
              onCancel={() => setConfirmacao(false)}
              focusCancelBtn
              reverseButtons
            >
              Deseja excluir Este Grupo!
            </SweetAlert>:null
           
          }

          {
           confirmacaoSub ? 
           <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle='ligth'
              title="Atenção"
              onConfirm={() =>deleteSubgrupo(confirmacaoId)}
              onCancel={() => setConfirmacaoSub(false)}
              focusCancelBtn
              reverseButtons
            >
              Deseja excluir Este SubGrupo!
            </SweetAlert>:null
           
          }

          {
           confirmacaoLinha ? 
           <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle='ligth'
              title="Atenção"
              onConfirm={() =>deleteLinha(confirmacaoId)}
              onCancel={() => setConfirmacaoLinha(false)}
              focusCancelBtn
              reverseButtons
            >
              Deseja excluir Esta Linha!
            </SweetAlert>:null
           
          }

           {
                      selectRelatorio ? 
                      <SweetAlert 
                       info
                       title="Selecione o tipo de relatório!" 
                       showCloseButton
                       onConfirm={() => setSelectRelatorio(false)} 
                       onCancel={() => setSelectRelatorio(false)}
                       customButtons={
                      <React.Fragment>
                        <div className='row'>
                        <div className="d-flex justify-content-center col-12 mb-2"> 
                          <select className='form-select' onChange={(e) => setTprelatorio(e.target.value)}>
                            <option value={0}>Ordenar por Código</option>
                            <option value={1}>Ordenado por Descrição</option>
                          </select>
                        </div>
                        <div className="d-flex justify-content-end col-12">
                  <button className="btn btn-primary mr-1 btn-lg" onClick={handleRelatorioGrupo}>PDF</button>
                  <button className="btn btn-success mr-1 btn-lg" onClick={handleRelatorioGrupoExcel}>Excel</button>
                 
                  
                  </div>
                  </div>
                      </React.Fragment>
                                       }
                         >
                       
                     </SweetAlert>:null
          
          
                    }

          {navegar ? <Navigate to='/app/grupo' /> && window.location.reload()  : null}
     
      </div> 
      {showModalSub && (
  <div className="modal show fade d-block mt-5" tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">

        {/* HEADER */}
        <div className="modal-header">
          <h5 className="modal-title">Adicionar Subgrupo</h5>
          <button 
            type="button" 
            className="btn-close"
            onClick={() => setShowModalSub(false)}
          ></button>
        </div>

        {/* BODY */}
        <div className="modal-body">

          <div className="mb-2">
            <label className="form-label">Código Grupo</label>
            <input 
              type="text"
              className="form-control"
              value={cod_grupo}
              disabled
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Código Subgrupo</label>
            <input 
              type="number"
              className="form-control"
              value={id}
              onChange={(e) => setId(e.target.value)}
              disabled
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Descrição</label>
            <input 
              type="text"
              className="form-control"
              value={descricaoSub}
              onChange={(e) => setDescricaoSub(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Markup</label>
            <input 
              type="number"
              className="form-control"
              value={markup}
              onChange={(e) => setMarkup(e.target.value)}
            />
          </div>

        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <button 
            className="btn btn-secondary"
            onClick={() => setShowModalSub(false)}
          >
            Cancelar
          </button>

          <button 
            className="btn btn-primary"
            onClick={salvaSubGrupo}
          >
            Salvar
          </button>
        </div>

      </div>
    </div>
  </div>
)}

{showModalLinha && (
  <div className="modal show fade d-block mt-5" tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">

        {/* HEADER */}
        <div className="modal-header">
          <h5 className="modal-title">Adicionar Linha</h5>
          <button 
            type="button" 
            className="btn-close"
            onClick={() => setShowModalLinha(false)}
          ></button>
        </div>

        {/* BODY */}
        <div className="modal-body">

          <div className="mb-2">
            <label className="form-label">Código SubGrupo</label>
            <input 
              type="text"
              className="form-control"
              value={cod_subgrupo}
              disabled
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Código Linha</label>
            <input 
              type="number"
              className="form-control"
              value={cod_linha}
              onChange={(e) => setCodLinha(e.target.value)}
              disabled
            />
          </div>

          <div className="mb-2">
            <label className="form-label">Descrição</label>
            <input 
              type="text"
              className="form-control"
              value={descricaoLinha}
              onChange={(e) => setDescricaoLinha(e.target.value)}
            />
          </div>

          

        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <button 
            className="btn btn-secondary"
            onClick={() => setShowModalLinha(false)}
          >
            Cancelar
          </button>

          <button 
            className="btn btn-primary"
            onClick={salvaLinha}
          >
            Salvar
          </button>
        </div>

      </div>
    </div>
  </div>
)}
      <FooterBar/>   
    </div>
}


export default Grupo;